import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=693b5bb2&scoped=true&"
import script from "./BasicForm.vue?vue&type=script&lang=js&"
export * from "./BasicForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicForm.vue?vue&type=style&index=0&id=693b5bb2&lang=scss&scoped=true&"
import style1 from "./BasicForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693b5bb2",
  null
  
)

export default component.exports